import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '@modules/primeng/primeng.module';

import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { SmartyModule } from '@modules/smarty.module';

@NgModule({
	declarations: [HeaderMenuComponent],
	imports: [CommonModule, PrimengModule, TranslateModule, SmartyModule],
	exports: [HeaderMenuComponent],
})
export class LayoutModule {}
